import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { connect } from 'react-redux';
import { _ } from '_locales';
import { Button } from '../../Education/components';

const Overview = ({
  colors, currentPage, setCurrentPage, bpData, bpItems,
}) => {
  const [expandedItems, setExpandedItems] = useState([]);
  const { main_color } = colors;

  const fee = Object.values(bpItems)[0]?.options[0]?.fee;
  const hasPayment = fee && fee !== '$0.00';
  return (
    <Container>
      <TextHeader>
        {bpData.bulk_pickup_config.header}
      </TextHeader>
      <Description
        dangerouslySetInnerHTML={{ __html: bpData.bulk_pickup_config.description }}
      />
      {bpData.has_advanced_settings ? (
        <View style={{ marginBottom: '30px' }}>
          <HeaderRow>
            <StyledText>
              {_('bulkPickup.accepted_items')}
            </StyledText>
            {hasPayment ? (
              <StyledText>
                {_('bulkPickup.fee_each')}
              </StyledText>
            ) : null}
          </HeaderRow>
          {Object.entries(bpItems).map(([key, value]) => (
            <ViewAccordion key={key}>
              <AccordionHeader
                onClick={() => setExpandedItems((s) => (s.includes(key)
                  ? s.filter((i) => i !== key) : [...s, key]))}
              >
                <AccordionTitle>
                  {value.name}
                </AccordionTitle>
                <AccordionIcon>
                  {expandedItems.includes(key) ? <FaChevronUp /> : <FaChevronDown />}
                </AccordionIcon>
              </AccordionHeader>
              {
                expandedItems.includes(key) && value.options.map((item, index) => (
                  <AccordionContent isLast={index === value.options.length - 1}>
                    <ItemText>{item.mat_nm}</ItemText>
                    {hasPayment ? (
                      <ItemFee>
                        {item.fee}
                      </ItemFee>
                    ) : null}
                  </AccordionContent>
                ))
              }
            </ViewAccordion>
          ))}
        </View>
      ) : null}
      <Button
        mainColor={main_color || false}
        margin="0 auto"
        aria-label={'Schedule a Pick-up Appointment'}
        fontSize="15px"
        padding="10px 12px"
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        {_('bulkPickup.schedule_a_pickup')}
      </Button>
    </Container>
  );
};

export default connect((state) => ({
  colors: state.config.templateColour ? JSON.parse(state.config.templateColour) : {},
}), null)(Overview);

const OpacityAnimation = keyframes`
  from { opacity: 0;}
  to { opacity:1;}
`;
const View = styled.div`
  animation: ${OpacityAnimation} 0.5s;
`;
const ViewAccordion = styled.div`
  border: 2px solid rgb(231, 236, 239);
  margin: 4px 0;
  transition: 0.3s;
  &:hover {
   box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  }
`;

const TextHeader = styled.h3`
  letter-spacing: 1px;
  cursor: pointer;
  margin: 0px !important;
  font-size: 18px !important;
  color: rgb(64, 64, 64) !important;
  font-weight: 600 !important;
  font-family: Roboto, sans-serif !important;
`;

const Description = styled.p`
  color: rgb(64, 64, 64);
  opacity: 0.8;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
`;

const Text = styled.p`
  color: rgb(64, 64, 64);
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
`;
const Container = styled.div`
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  margin-bottom: 35px;
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledText = styled(Text)`
  font-size: 14px;
  color: #6C7293;
  letter-spacing: 1px;
  font-weight: 600;
  padding: 0 10px;
`;

const AccordionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 3px;
  border-bottom: 1px solid rgb(231, 236, 239);
`;

const AccordionTitle = styled(Text)`
  padding: 0 15px;
  font-size: 20px;
  font-weight: 600;
  color: #000;
`;

const AccordionIcon = styled(Text)`
  padding: 0 15px;
  font-size: 710px;
`;

const AccordionContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: ${({ isLast }) => !isLast && '1px solid rgb(231, 236, 239)'};
`;

const ItemText = styled(Text)`
  padding: 0 15px;
  font-weight: 400;
  color: #000;
`;

const ItemFee = styled(Text)`
  padding: 0 15px;
  font-weight: bold;
  color: rgb(24, 123, 193);
  letter-spacing: 0.3px;
`;
